//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbCheckbox from '@/elements/forms/rb-checkbox.vue'

import { mapGetters } from 'vuex'

import { sameAs } from 'vuelidate/lib/validators'
import wcs from '@/scripts/libs/wcs'

import {
  RAYBAN_STORES,
  CERTIFIED,
  PREMIUM,
  STORIES,
  APPOINTMENT,
  LENS_SWAP,
} from '@/scripts/constants/store-locator'
import { TRACKER_CLICK, TRACKER_HIDDEN_ACTION } from '@/scripts/constants/tracker'

export const TOGGLE_FILTER = 'toggleFilter'

export const FILTERS = [
  {
    id: RAYBAN_STORES,
  },
  {
    id: PREMIUM,
  },
  {
    id: CERTIFIED,
  },
]

export const FILTERS_INDIA = [
  {
    id: PREMIUM,
  },
  {
    id: CERTIFIED,
  },
]

export default {
  name: 'rb-store-locator-filters',
  components: {
    RbCheckbox,
  },
  props: {
    activeFilters: {
      type: Array,
      default: () => [],
    },
    filtersAreDisabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    locale: {
      type: String,
      default: '',
    },
    isInsourcing: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filters: FILTERS,
      checkboxes: [],
      appointment: '',
      stories: '',
      lensswap: '',
    }
  },
  validations() {
    return {
      stories: {
        sameAs: sameAs(() => 'true'),
      },
      appointment: {
        sameAs: sameAs(() => 'true'),
      },
      lensswap: {
        sameAs: sameAs(() => 'true'),
      },
    }
  },
  computed: {
    ...mapGetters(['translation']),
  },
  watch: {
    locale(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterAvailableCheckboxes(newVal)
      }
    },
  },
  mounted() {
    this.filterAvailableCheckboxes(this.locale)
    this.preSelectCheckboxes()
    if (this.isInsourcing !== '') {
      this.filters = FILTERS_INDIA
    }
  },
  methods: {
    filterAvailableCheckboxes(locale) {
      const { storeLocator } = wcs.getStoreConfig()
      const countryFromLocale = locale?.split('-')[1]

      const isCountryWithStella = storeLocator?.stellaCountries?.includes(countryFromLocale)
      if (isCountryWithStella || this.isInsourcing) {
        if (!this.checkboxes.some((checkbox) => checkbox.id === STORIES)) {
          this.checkboxes.push({
            id: STORIES,
          })
        }
      } else {
        this.checkboxes = this.checkboxes.filter((checkbox) => checkbox.id !== STORIES)
      }
      const doesCountryHaveBookAnAppointment =
        storeLocator?.countriesWithBookAnAppointment?.includes(countryFromLocale)

      if (doesCountryHaveBookAnAppointment) {
        if (!this.checkboxes.some((checkbox) => checkbox.id === APPOINTMENT)) {
          this.checkboxes.push({
            id: APPOINTMENT,
          })
        }
      } else {
        this.checkboxes = this.checkboxes.filter((checkbox) => checkbox.id !== APPOINTMENT)
      }

      const countryHasLensSwap = storeLocator.countriesWithLensSwap?.includes(countryFromLocale)
      if (countryHasLensSwap) {
        if (!this.checkboxes.some((checkbox) => checkbox.id === LENS_SWAP)) {
          this.checkboxes.push({
            id: LENS_SWAP,
          })
        }
      } else {
        this.checkboxes = this.checkboxes.filter((checkbox) => checkbox.id !== LENS_SWAP)
      }
    },
    toggleCheckbox(checkboxId) {
      if (this.loading) {
        return
      }
      if (this.filtersAreDisabled) {
        return
      }
      this.$data[checkboxId] = !this.$data[checkboxId]
      this.$nextTick(() => this.toggleFilter(checkboxId))
    },
    toggleFilter(filterId) {
      if (this.loading) {
        return
      }
      this.$emit(TOGGLE_FILTER, filterId)
      const isFilterStoreType = this.filters.some((filter) => filter.id === filterId)
      if (isFilterStoreType) {
        this.$ma.trackEvent({
          event: TRACKER_CLICK,
          value: {
            Tracking_Type: TRACKER_HIDDEN_ACTION,
            data_element_id: 'X_X_StoreFilter_Choose',
            data_description: filterId,
          },
        })
      }
    },
    isFilterToggled(filterId) {
      return this.activeFilters.includes(filterId)
    },
    preSelectCheckboxes() {
      this.stories = this.activeFilters.includes(STORIES)
      this.appointment = this.activeFilters.includes(APPOINTMENT)
      this.lensswap = this.activeFilters.includes(LENS_SWAP)
    },
    getFilterIcon(filterId) {
      return `common__icon--physical-store-${filterId}`
    },
    translateFilterLabel(id) {
      const translationKey = 'store_locator.filters.' + id
      if (this.$te(translationKey)) {
        return this.$t(translationKey)
      }
      return this.translation(translationKey)
    },
    getInitialValue(checkboxId) {
      return this.$data[checkboxId] ? 'true' : ''
    },
  },
}
